class WishlistToast extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.epi = ''
  }

  setupListeners () {
    this.els.close.element.addEventListener('click', () => {
      this.style.opacity = '0'
      this.style.zIndex = '-1'
    })

    document.addEventListener('swym-item-added', data => {
      this.renderToast(data.detail.details)
    })
  }

  renderToast (details) {
    const { wishlistName, productImage, productTitle } = details

    const image = document.createElement('img')
    image.src = productImage
    image.alt = productTitle
    image.classList.add('wsh-WishlistToast_Image')

    let message = this.dataset.message
    message = message.replace(
      '[wishlistName]',
      `<span class="fz-14_150-bold wsh-WishlistToast_WishlistName">${wishlistName}</span>`,
    )
    message = message.replace(
      '[productTitle]',
      `<span class="fz-14_150-bold wsh-WishlistToast_ProductTitle">${productTitle}</span>`,
    )

    this.els.message.element.innerHTML = message

    this.els.imageContainer.element.innerHTML = ''
    this.els.imageContainer.element.appendChild(image)

    this.style.opacity = '1'
    this.style.zIndex = '1000'

    setTimeout(() => {
      this.style.opacity = '0'
      this.style.zIndex = '-1'
    }, this.dataset.duration * 1000)
  }
}

if (!customElements.get('wishlist-toast')) {
  customElements.define('wishlist-toast', WishlistToast)
}
